module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-periodic-table"
  }, [_c('element-general-properties', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (Object.keys(_vm.selectedElement).length > 0),
      expression: "Object.keys(selectedElement).length > 0"
    }],
    staticClass: "c-information",
    attrs: {
      "element": _vm.selectedElement,
      "preview": true
    }
  }), _vm._v(" "), _vm._l((_vm.elements), function(element) {
    return _c('div', {
      staticClass: "element",
      class: element.symbol && element.symbol.toLowerCase(),
      style: ({
        opacity: _vm.filteredElements.includes(element.atomicNumber) ? 1 : 0.25
      }),
      attrs: {
        "data-element-group": element.elementGroup,
        "data-group": element.group,
        "data-period": element.period
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/element/' + element.atomicNumber
      },
      nativeOn: {
        "mouseover": function($event) {
          _vm.showElement(element)
        },
        "mouseout": function($event) {
          _vm.hideElement()
        }
      }
    }, [_c('element-definition', {
      staticClass: "u-aspect-ratio",
      attrs: {
        "element": element,
        "detailed": true
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "element lanthanoid",
    style: ({
      opacity: _vm.filteredElementsContainElementsOfGroup('lanthanoid') ? 1 : 0.25
    }),
    attrs: {
      "data-element-group": "lanthanoid"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "element actinoid",
    style: ({
      opacity: _vm.filteredElementsContainElementsOfGroup('actinoid') ? 1 : 0.25
    }),
    attrs: {
      "data-element-group": "actinoid"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20076387"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PeriodicTable.vue
// module id = 636
// module chunks = 1